var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 292 292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#282828;stroke:#fe757d;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:#fe757d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "66 0 66 6 6 6 6 66 0 66 0 0 66 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "292 226 292 292 226 292 226 286 286 286 286 226 292 226"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6,
    y: 6,
    width: 280,
    height: 280
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupWarning);
export default __webpack_public_path__ + "static/media/popup_warning.8242b05f7b84e73ee3e43b7c8ea38a59.svg";
export { ForwardRef as ReactComponent };